import moment from 'moment';
import _ from 'lodash';

export const FATED_AFFIXES = [
  {
    name: 'Chaotic Essence',
    icon: 'inv_trinket_progenitorraid_01_green'
  },
  {
    name: 'Creation Spark',
    icon: 'inv_progenitor_rarereagent'
  },
  {
    name: 'Protoform Barrier',
    icon: 'inv_ring_progenitorraid_03_yellow'
  },
  {
    name: 'Reconfiguration Emitter',
    icon: 'inv_progenitorbird'
  }
];

// !!! Must match order of FATED_AFFIXES !!!
export const enum FatedAffixIndex {
  CHAOTIC_ESSENCE = 0,
  CREATION_SPARK = 1,
  PROTOFORM_BARRIER = 2,
  RECONFIGURATION_EMITTER = 3
}

export const AllFatedAffixes = [
  FatedAffixIndex.CHAOTIC_ESSENCE,
  FatedAffixIndex.CREATION_SPARK,
  FatedAffixIndex.PROTOFORM_BARRIER,
  FatedAffixIndex.RECONFIGURATION_EMITTER
];

export const XCC_BOSS_AFFIXES: any = {
  'castle-nathria': {
    'hungering-destroyer': [FatedAffixIndex.CHAOTIC_ESSENCE, FatedAffixIndex.RECONFIGURATION_EMITTER],
    'sun-kings-salvation': [FatedAffixIndex.CHAOTIC_ESSENCE, FatedAffixIndex.CREATION_SPARK],
    'artificer-xymox': [FatedAffixIndex.CREATION_SPARK, FatedAffixIndex.RECONFIGURATION_EMITTER],
    'lady-inerva-darkvein': [FatedAffixIndex.RECONFIGURATION_EMITTER, FatedAffixIndex.CHAOTIC_ESSENCE],
    'the-council-of-blood': [FatedAffixIndex.PROTOFORM_BARRIER, FatedAffixIndex.CREATION_SPARK],
    sludgefist: [FatedAffixIndex.CREATION_SPARK, FatedAffixIndex.PROTOFORM_BARRIER],
    'stone-legion-generals': [FatedAffixIndex.RECONFIGURATION_EMITTER, FatedAffixIndex.CREATION_SPARK],
    'sire-denathrius': [FatedAffixIndex.PROTOFORM_BARRIER, FatedAffixIndex.RECONFIGURATION_EMITTER]
  },

  'sepulcher-of-the-first-ones': {
    'artificer-xymox': [FatedAffixIndex.CHAOTIC_ESSENCE, FatedAffixIndex.CREATION_SPARK],
    lihuvim: [FatedAffixIndex.RECONFIGURATION_EMITTER, FatedAffixIndex.CHAOTIC_ESSENCE],
    'prototype-pantheon': [FatedAffixIndex.PROTOFORM_BARRIER, FatedAffixIndex.CREATION_SPARK],
    halondrus: [FatedAffixIndex.CREATION_SPARK, FatedAffixIndex.RECONFIGURATION_EMITTER],
    'anduin-wrynn': [FatedAffixIndex.PROTOFORM_BARRIER, FatedAffixIndex.RECONFIGURATION_EMITTER],
    'lords-of-dread': [FatedAffixIndex.CHAOTIC_ESSENCE, FatedAffixIndex.PROTOFORM_BARRIER],
    rygelon: [FatedAffixIndex.CREATION_SPARK, FatedAffixIndex.PROTOFORM_BARRIER],
    'the-jailer': [FatedAffixIndex.RECONFIGURATION_EMITTER, FatedAffixIndex.CREATION_SPARK]
  }
};

export const XCC_CHECKPOINTS = [
  {
    id: 1,
    raid: 'sepulcher-of-the-first-ones',
    name: 'CHECKPOINT 1',
    bosses: ['artificer-xymox', 'lihuvim', 'prototype-pantheon'],
    prizes: [10000, 5000]
  },
  {
    id: 2,
    raid: 'sepulcher-of-the-first-ones',
    name: 'CHECKPOINT 2',
    bosses: ['halondrus', 'anduin-wrynn'],
    prizes: [10000, 5000]
  },
  {
    id: 3,
    raid: 'sepulcher-of-the-first-ones',
    name: 'FINAL',
    bosses: ['lords-of-dread', 'rygelon', 'the-jailer'],
    prizes: [12500, 7500]
  },

  {
    id: 4,
    raid: 'castle-nathria',
    name: 'CHECKPOINT 1',
    bosses: ['hungering-destroyer', 'sun-kings-salvation', 'artificer-xymox'],
    prizes: [10000, 5000]
  },
  {
    id: 5,
    raid: 'castle-nathria',
    name: 'CHECKPOINT 2',
    bosses: ['lady-inerva-darkvein', 'the-council-of-blood', 'sludgefist'],
    prizes: [10000, 5000]
  },
  {
    id: 6,
    raid: 'castle-nathria',
    name: 'FINAL',
    bosses: ['stone-legion-generals', 'sire-denathrius'],
    prizes: [12500, 7500]
  }
];

export const XCC_CHECKPOINT_BY_BOSS_AND_RAID = XCC_CHECKPOINTS.reduce((accum: any, cp: any) => {
  if (!accum[cp.raid]) {
    accum[cp.raid] = {};
  }
  // first to defeat last boss wins the checkpoint
  accum[cp.raid][cp.bosses[cp.bosses.length - 1]] = cp;
  return accum;
}, {});

export const XCC_ALL_BOSSES = XCC_CHECKPOINTS.reduce((accum: any, cp: any) => {
  for (const boss of cp.bosses) {
    accum[boss] = cp;
  }
  return accum;
}, {});

const XCC_LIQUID_GUILD_ID = 1803240;
const XCC_ECHO_GUILD_ID = 1739612;

const XCC_BASE_EARNINGS_FOR_RAID_AND_GUILD: any = {
  'sepulcher-of-the-first-ones': {
    [XCC_ECHO_GUILD_ID]: 32500,
    [XCC_LIQUID_GUILD_ID]: 17500
  }
};

export function processXCCEarnings(guilds: any[]) {
  const byGuildAndBoss: any = {};
  const byGuild: any = {};
  const placementByGuildAndBoss: any = {};
  const killsByBoss: any = {};

  guilds.forEach((guild: any, index: number) => {
    byGuildAndBoss[index] = {};
    byGuild[index] = XCC_BASE_EARNINGS_FOR_RAID_AND_GUILD[guild.raid.slug]?.[guild.guild.id] || 0;
    placementByGuildAndBoss[index] = {};

    for (const boss of guild.allBosses) {
      if (!boss.isDefeated) {
        continue;
      }

      if (!XCC_CHECKPOINT_BY_BOSS_AND_RAID[guild.raid.slug]) {
        // we only care about checkpoint bosses (last in each checkpoint)
        continue;
      }

      const checkpoint = XCC_CHECKPOINT_BY_BOSS_AND_RAID[guild.raid.slug][boss.boss.slug];
      if (!checkpoint) {
        continue;
      }

      if (!killsByBoss[boss.boss.slug]) {
        killsByBoss[boss.boss.slug] = [];
      }

      killsByBoss[boss.boss.slug].push({
        time: moment.utc(boss.pullEndedAt),
        guild,
        checkpoint,
        guildIndex: index
      });
    }
  });

  for (const kills of Object.values<any>(killsByBoss)) {
    // sort them all by earliest time so we know who got first place
    kills.sort((a: any, b: any) => a.time - b.time);

    for (const prizeIndex of _.range(kills[0].checkpoint.prizes.length)) {
      const kill = kills[prizeIndex];
      if (kill) {
        const value = kill.checkpoint.prizes[prizeIndex];

        // indicate how much money they earned in aggregate
        byGuild[kill.guildIndex] += value;

        // indicate how much money they won on a specific boss
        byGuildAndBoss[kill.guildIndex][kill.checkpoint.bosses[kill.checkpoint.bosses.length - 1]] = value;

        placementByGuildAndBoss[kill.guildIndex][kill.checkpoint.bosses[kill.checkpoint.bosses.length - 1]] =
          1 + prizeIndex;
      }
    }
  }

  return {
    byGuild,
    byGuildAndBoss,
    placementByGuildAndBoss
  };
}
